import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLightLabor = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "lightLabor",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_16856",
		"data-name": "Group 16856",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12501",
				"data-name": "Path 12501",
				d: "M1,9v8",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12502",
				"data-name": "Path 12502",
				d: "M12,3V7",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12503",
				"data-name": "Path 12503",
				d: "M9,3h6",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12504",
				"data-name": "Path 12504",
				d: "M20,9v2H18L16,7H8L6,9H4v8H7l1.724,3.447A1,1,0,0,0,9.618,21H16a1,1,0,0,0,1-1V17h3v2h2a1,1,0,0,0,1-1V10a1,1,0,0,0-1-1Z",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12505",
				"data-name": "Path 12505",
				d: "M4,13H1",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_12506",
		"data-name": "Path 12506",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgLightLabor;
